module.exports = __webpack_public_path__ + "img/item5.9f0c25dd.png";